// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"592ec49f","667":"7d9523e8"}[chunkId] + ".chunk.js";
};